const API_BASE_URL = "https://api.videosdk.live";
const VIDEOSDK_TOKEN = process.env.REACT_APP_VIDEOSDK_TOKEN;
const API_AUTH_URL = process.env.REACT_APP_AUTH_URL;

export const getToken = async () => {
  if (VIDEOSDK_TOKEN && API_AUTH_URL) {
    console.error(
      "Error: Provide only ONE PARAMETER - either Token or Auth API"
    );
  } else if (VIDEOSDK_TOKEN) {
    return VIDEOSDK_TOKEN;
  } else if (API_AUTH_URL) {
    const res = await fetch(`${API_AUTH_URL}/get-token`, {
      method: "GET",
    });
    const { token } = await res.json();
    return token;
  } else {
    console.error("Error: ", Error("Please add a token or Auth Server URL"));
  }
};

export const createMeeting = async ({ token }) => {
  const url = `${API_BASE_URL}/v2/rooms`;
  const options = {
    method: "POST",
    headers: { Authorization: token, "Content-Type": "application/json" },
    body: JSON.stringify({
      'autoCloseConfig': {
        'type': 'session-ends',//'session-end-and-deactivate',
        'duration': 20
      },
      /*'autoStartConfig': {
        'recording': {
          'transcription': {
            'enabled': true,
            'summary': {
              'enabled': true,
              'prompt': 'Redactar un resumen en secciones como Título, Agenda, Oradores, Puntos de acción, Esquemas, Notas y Resumen.'
            }
          },
          'config': {
            'layout': {
              'type': 'GRID',
              'priority': 'SPEAKER',
              'gridSize': 4
            }
          }
        },
        /*'hls': {
          'transcription': {
            'enabled': true,
            'summary': {
              'enabled': true,
              'prompt': 'Redactar un resumen en secciones como Título, Agenda, Oradores, Puntos de acción, Esquemas, Notas y Resumen.'
            }
          },
          'config': {
            'layout': {
              'type': 'GRID',
              'priority': 'SPEAKER',
              'gridSize': 4
            },
            'recording': {
              'enabled': 'true'
            }
          }
        }* /
      }*/
    }),
  };

  const response = await fetch(url, options)
  const data = await response.json()

  if (data.roomId) {
    return { meetingId: data.roomId, err: null }
  } else {
    return { meetingId: null, err: data.error }
  }

};

export const validateMeeting = async ({ roomId, token }) => {
  const url = `${API_BASE_URL}/v2/rooms/validate/${roomId}`;
  const options = {
    method: "GET",
    headers: { Authorization: token, "Content-Type": "application/json" },
  };

  const response = await fetch(url, options)

  if (response.status === 400) {
    return { meetingId: null, err: "Sala no Existe" }
  }
  else if (response.status === 401) {
    return { meetingId: null, err: "Token invalido" }
  }
  const data = await response.json()
  if (data.roomId && data.disabled === false) {
    return { meetingId: data.roomId, err: null }
  } else {
    return { meetingId: null, err: 'Sala de atencion invalida, verifique su correo electronico.' }
  }
};

export const info_cita = async ({ roomId, emp }) => {
  //const url=`http://localhost/sidi_api/LoginTurnero/datedate/${roomId}/${emp}`;
  //const url = `https://citasonline.medicinaintegralips.com/get-token/?e=bgfghgfh&c=24`;
  //const url = `${API_AUTH_URL}/get-token/?e=${emp}&c=${roomId}`;
  const url = `${API_AUTH_URL}/my-api/public/Teleconsulta/datos_cita/${roomId}/${emp}`
  //const url = `http://localhost/sidi_api/LoginTurnero/datedate/${roomId}/${emp}`
  const options = {
    method: "GET",
    headers: { Authorization: VIDEOSDK_TOKEN, "Content-Type": "application/json" },
  };
  try {
    const response = await fetch(url, options)
    return await response.json();
  } catch (error) {
    /* estados de las citas
      1 Reservada
      2 Perdida
      3 Confirmada
      4 Atendida
      5 No atendida
      6 Cancelada
  */
    // console.error("Error: ", error);
    /* return  {
       "cita": null,
       "sala": null,
       "empresa": null
     };*/
    return {
"sala": "bw8a-dvy0-k9cl",
"cita": {
"consentimiento": 0,
"estado": 1,
"start": "2025-07-09 06:45:00.0000000",
"end": "2025-07-09 07:20:00.0000000",
"id": 5053,
"title": "Paciente: (TI:61976833)-LAURAN  DIAZZ HARISDV. Especialista: CRISTIAN MOGOLLON (BARRANQUILLA 5:00AM 8:00AM)(2025-06-01=>2026-06-20)(INFECTOLOGIA V).",
"id_paciente": 0,
"id_profesional": 469,
"profesionales_jm": ",469,458,",
"medico": "CRISTIAN MOGOLLON (BARRANQUILLA 5:00AM 8:00AM)",
"paciente": "LAURAn DIAZZ HARISdv (TI:61976833)",
"programa": "Infectologia",
"cups": "890301",
"usuario": "CMOGOLLON",
"servicios": "CONSULTA DE CONTROL O DE SEGUIMIENTO POR MEDICINA GENERAL",
"especialidad": "INFECTOLOGIA V"
},
"empresa": {
"id": 72,
"logo": "http://190.131.206.250/sidi/archivo/empresa/72/logo.png",
"nombre": "TEST DESARROLLO",
"nit": "12365478",
"colores": [
"#666666",
"#3e80ea"
]
}
}
  }
}